import { render, staticRenderFns } from "./achivelist.vue?vue&type=template&id=319dc175&scoped=true"
import script from "./achivelist.vue?vue&type=script&lang=js"
export * from "./achivelist.vue?vue&type=script&lang=js"
import style0 from "./achivelist.vue?vue&type=style&index=0&id=319dc175&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319dc175",
  null
  
)

export default component.exports